import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import HeaderComponent from '../components/General/HeaderComponent';
import ButtonComponent from '../components/General/Button';
import { clearProjectDetails } from '../store/createProjectState';

export default function CreateProjectFinish() {
  const dispatch = useDispatch();
  const { projectDetails } = useSelector((state) => state.createProjectState);

  // Proje oluşturma tamamlandığında store'u temizle
  useEffect(() => {
    // 3 saniye sonra store'u temizle (kullanıcı sonucu görebilsin)
    const timer = setTimeout(() => {
      dispatch(clearProjectDetails());
    }, 3000);

    return () => clearTimeout(timer);
  }, [dispatch]);

  return (
    <div className="w-full dark:bg-dark-100 bg-stone-100 min-h-screen">
      <div className="container mx-auto">
        <HeaderComponent title="Proje Oluşturuldu!" />
        
        <div className="flex justify-center items-center mt-8">
          <div className="bg-white dark:bg-dark-300 p-8 rounded-lg shadow-lg max-w-2xl w-full text-center">
            <div className="mb-8">
              {/* Success Icon */}
              <div className="mx-auto w-20 h-20 bg-green-100 dark:bg-green-900 rounded-full flex items-center justify-center mb-4">
                <svg 
                  className="w-10 h-10 text-green-600 dark:text-green-400" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M5 13l4 4L19 7" 
                  />
                </svg>
              </div>

              <h2 className="text-3xl font-semibold text-gray-900 dark:text-white mb-4">
                Tebrikler!
              </h2>
              <p className="text-lg text-gray-600 dark:text-gray-300 mb-2">
                Projeniz başarıyla oluşturuldu.
              </p>
              <p className="text-xl font-semibold text-red-600 dark:text-violet-400">
                "{projectDetails.pname || 'Yeni Proje'}"
              </p>
            </div>

            <div className="bg-gray-50 dark:bg-dark-500 p-6 rounded-lg mb-8">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                Sonraki Adımlar
              </h3>
              <ul className="text-left space-y-2 text-gray-700 dark:text-gray-300">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-red-600 dark:bg-violet-500 rounded-full mr-3"></span>
                  Ekip üyelerini projeye davet edin
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-red-600 dark:bg-violet-500 rounded-full mr-3"></span>
                  İlk görevlerinizi oluşturun
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-red-600 dark:bg-violet-500 rounded-full mr-3"></span>
                  Proje zaman çizelgesini belirleyin
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-red-600 dark:bg-violet-500 rounded-full mr-3"></span>
                  İlerleme takibini başlatın
                </li>
              </ul>
            </div>

            <div className="flex justify-center space-x-4">
              <ButtonComponent
                href="/projects"
                title="Projelerim"
                bgcolor="bg-gray-100 text-black rounded-xl w-44 dark:bg-dark-300 dark:text-gray-300 hover:bg-stone-200 border-2 dark:border-dark-500 dark:hover:border-violet-500"
              />
              <ButtonComponent
                href="/dashboard"
                title="Dashboard"
                bgcolor="bg-red-600 rounded-xl text-white w-44 dark:bg-violet-500 hover:bg-violet-500"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
